import { Link, Outlet } from 'react-router-dom';
import type { ReactNode } from 'react';

/**
 * Auth pages shell.
 *
 * Mirrors `.old/resources/views/auth/login.blade.php` standalone layout:
 *  - top navbar with attribute logo only (no admin nav)
 *  - centered `account-pages` card container
 *  - footer copyright line
 *
 * Render as `<AuthLayout><LoginPage /></AuthLayout>` or via Router using
 * `<Outlet />`.
 */
export function AuthLayout({ children }: { children?: ReactNode } = {}) {
  return (
    <div className="d-flex flex-column min-vh-100">
      <div className="navbar-custom topnav-navbar shadow-sm mb-1 clearfix">
        <div className="container-fluid d-flex d-lg-none justify-content-between">
          <div style={{ width: 65 }}>&nbsp;</div>
          <Link to="/" className="topnav-logo">
            <img src="/attribute/ads.png" alt="" style={{ height: 'auto', maxHeight: '5vh', minHeight: 70 }} />
          </Link>
          <div style={{ width: 65 }}>&nbsp;</div>
        </div>

        <div className="container-fluid d-none d-lg-block">
          <Link to="/" className="topnav-logo">
            <span className="topnav-logo-lg">
              <img src="/attribute/ads.png" alt="" height={70} />
            </span>
          </Link>
          <Link to="/" className="topnav-text">
            <span>FlexStorm Project Planner</span>
          </Link>
        </div>
      </div>

      <div className="account-pages mt-3 mb-4" style={{ minHeight: '85vh' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-4 col-lg-5">{children ?? <Outlet />}</div>
          </div>
        </div>
      </div>

      <footer className="footer footer-alt mt-auto">
        <div className="container-fluid text-center">
          <span className="lh-lg">
            &copy; {new Date().getFullYear()} Advanced Drainage Systems&trade;. All&nbsp;rights&nbsp;reserved.
          </span>
        </div>
      </footer>
    </div>
  );
}
